import { mergeSx } from "@/utils";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";
import { SvgIcon } from "../SvgIcon";

export function ImmutableSymbolSolidInverse({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("ImmutableSymbolSolid");
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 33 32"
      sx={mergeSx(
        {
          w: "32px",
          circle: { fill: "base.color.brand.1" },
          path: { fill: "base.color.brand.2" },
        },
        sx,
      )}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}

ImmutableSymbolSolidInverse.displayName = "ImmutableSymbolSolidInverse";
